var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurrentLocationImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0834 7.50002C12.0834 8.6506 11.1507 9.58335 10.0001 9.58335C8.8495 9.58335 7.91675 8.6506 7.91675 7.50002C7.91675 6.34943 8.8495 5.41669 10.0001 5.41669C11.1507 5.41669 12.0834 6.34943 12.0834 7.50002Z",
    stroke: "#404D5C",
    strokeWidth: 1.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1851 14.1667C16.3472 15.8238 16.9031 16.7063 16.572 17.4166C16.5387 17.4879 16.4998 17.5566 16.4557 17.6223C15.9769 18.3334 14.7395 18.3334 12.2648 18.3334H7.73511C5.26034 18.3334 4.02296 18.3334 3.54417 17.6223C3.49996 17.5566 3.46108 17.4879 3.42788 17.4166C3.09674 16.7063 3.65263 15.8238 4.81473 14.1667",
    stroke: "#404D5C",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0479 14.578C10.7668 14.8487 10.3912 15 10.0002 15C9.60925 15 9.23358 14.8487 8.9525 14.578C6.37866 12.084 2.92941 9.29794 4.61151 5.25313C5.521 3.06612 7.7042 1.66669 10.0002 1.66669C12.2962 1.66669 14.4794 3.06613 15.3889 5.25313C17.0689 9.29285 13.6281 12.0926 11.0479 14.578Z",
    stroke: "#404D5C",
    strokeWidth: 1.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrentLocationImg);
export default __webpack_public_path__ + "static/media/current-location-img.1f7205f7beb2d792b2ae7d2ac4c32168.svg";
export { ForwardRef as ReactComponent };